import type {PublicMethodUtils} from '@wix/document-services-types'
import type {InnerElementsPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<InnerElementsPublicAPI> {
    const {getter, dataManipulation} = publicMethodUtils.extensionPublicAPI
    const {defineAction, deprecate} = publicMethodUtils
    return {
        methods: {
            components: {
                innerElements: {
                    getDefinition: getter('innerElements.getDefinition'),
                    setManifests: deprecate(
                        defineAction(() => {}),
                        'setManifests is deprecated! You should load your manifest by installing the application with the builder components'
                    ),
                    getInnerElementBoundingBoxes: getter('viewer.getInnerElementBoundingBoxes'),
                    serializeInnerElementPath: getter('innerElements.serializeInnerElementPath'),
                    cssStyle: {
                        get: getter('innerElements.getInnerElementStyle'),
                        update: dataManipulation('innerElements.setInnerElementStyle'),
                        remove: dataManipulation('innerElements.removeInnerElementStyleProperties'),
                        connectToGlobalStyle: dataManipulation('innerElements.connectToGlobalStyle'),
                        scoped: {
                            remove: dataManipulation('innerElements.scoped.removeStyle')
                        }
                    },
                    data: {
                        get: getter('innerElements.getInnerElementData'),
                        getTranslationOverrides: getter('innerElements.getInnerElementTranslationOverrides'),
                        set: dataManipulation('innerElements.setInnerElementData'),
                        removeTranslationOverrides: dataManipulation(
                            'innerElements.removeInnerElementTranslationOverrides'
                        ),
                        removeTranslationOverridesForAField: dataManipulation(
                            'innerElements.removeInnerElementTranslationOverridesForAField'
                        ),
                        removeProperties: dataManipulation('innerElements.removeInnerElementDataProperties')
                    },
                    slots: {
                        populate: dataManipulation('innerElements.setInnerElementSlots', {
                            getReturnValueMethodPath: 'slots.getComponentToAddRef'
                        }),
                        getSlotsData: getter('innerElements.getInnerElementSlots'),
                        getPopulatedComponentContainerInfoMap: getter(
                            'innerElements.getInnerElementPopulatedComponentContainerInfoMap'
                        ),
                        remove: dataManipulation('innerElements.removeInnerElementSlot')
                    },
                    presets: {
                        get: getter('innerElements.getInnerElementPresets'),
                        set: dataManipulation('innerElements.setInnerElementPresets')
                    },
                    remove: dataManipulation('innerElements.removeInnerElement'),
                    bindings: {
                        bind: dataManipulation('innerElements.bindings.bind'),
                        bindAll: dataManipulation('innerElements.bindings.bindAll'),
                        unbindProperties: dataManipulation('innerElements.bindings.unbindProperties'),
                        getBoundProperties: getter('innerElements.bindings.getBoundProperties'),
                        unbind: dataManipulation('innerElements.bindings.unbind'),
                        functions: {
                            bind: dataManipulation('innerElements.bindings.functions.bind')
                        },
                        templates: {
                            bind: dataManipulation('innerElements.bindings.templates.bind')
                        }
                    }
                }
            }
        }
    }
}
